/**
 * stores/user.ts
 *
 * Authenticated user state store
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
    const firebaseUid = ref<string | null>(null)
    const googleUid = ref<string | null>(null)
    const userEmail = ref<string | null>(null)
    const encryptionKey = ref<string | null>(null) // hex-encoded, from `userSecrets`

    function setUser (fbUid: string, gUid: string | null, email: string | null) {
        firebaseUid.value = fbUid
        googleUid.value = gUid
        userEmail.value = email
    }

    function clearUser () {
        firebaseUid.value = null
        googleUid.value = null
        userEmail.value = null
        encryptionKey.value = null
    }

    return {
        firebaseUid,
        googleUid,
        userEmail,
        encryptionKey,
        setUser,
        clearUser,
    }
})
